module.exports = __webpack_public_path__ + "static/media/flyerColinas.d0924df8.webp";